import {Component, Input, OnInit} from '@angular/core';
import {Asset} from '../../shared/domain/item';
import {appConfig} from '../../shared/app.config';
import {ComponentizedEquipment} from '../../equipment-core/equipment-componentization/shared/componentized-equipment.model';
import {ItemSummaryItemSummaryService} from '../../shared/asset/item-summary-item-summary.service';

@Component({
  selector: 'lib-item-summary-item-componentization',
  templateUrl: './item-componentization.component.html',
  styleUrls: ['./item-componentization.component.scss']
})
export class ItemComponentizationComponent implements OnInit {
  @Input() itemId: number;
  @Input() asset: Asset;
  @Input() itemSummaryService: ItemSummaryItemSummaryService;

  componentizedItem: ComponentizedEquipment;

  ngOnInit(): void {
    this.componentizedItem = ComponentizedEquipment.fromJson(this.asset);
    this.componentizedItem.parentComponent = this.asset.parentComponentLot;
    this.componentizedItem.setAuctionStatusId(this.asset.auctionStatus);
    this.componentizedItem.description = this.asset.customDescrTxt;
  }

  navigateToItem(assetId: number) {
    const url = `/opportunity/asset-packages/${this.asset.assetControlGroupId}/assets/${assetId}/summary`;
    window.open(appConfig.assetManagementPortalRoot + url, '_blank');
  }

  refreshAssetInfo() {
    this.itemSummaryService.getItem(this.itemId);
  }
}
